import { createReducer } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { Nullable } from 'modules/types/common';
import * as actions from 'store/booking/actions.common';

export type MetadataState = Readonly<{
  correlationID?: Nullable<string>;
}>;

export const metadataInitialState: MetadataState = {
  correlationID: null
};

export const metadataReducer = createReducer(metadataInitialState, {
  [actions.SET_CORRELATION_ID]: state => {
    if (!state.correlationID) {
      state.correlationID = uuidv4();
    }
  },
  [actions.CLEAR_CORRELATION_ID]: state => {
    state.correlationID = null;
  }
});
